import {
    Component
} from '@angular/core';
import {
    BaseMatTableMagicComponent,
    matMagicProviders
} from "@magic-xpa/angular-material-core";
//
import { FormControl, FormGroup } from '@angular/forms'; 
import { variable } from '@angular/compiler/src/output/output_ast';
//
@Component({
    selector: 'mga-ConsultaAcompanhamento',
    providers: [...matMagicProviders],
    styleUrls: ['./ConsultaAcompanhamento.component.css'],
    templateUrl: './ConsultaAcompanhamento.component.html'
}) export class ConsultaAcompanhamento extends BaseMatTableMagicComponent {
    displayedColumns = ['Column2',
        'Column3',
        'Column4',
        'Column5',
    ];
	
	//
	// 2020-11-04 (MFCS)
	//
    ngOnInit() {
        super.ngOnInit();
        let group: FormGroup = this.screenFormGroup; 
        (<FormControl>group.controls['vFlag_to_Attach']).registerOnChange(this.OnChange.bind(this));
    }
    OnChange() {
        if(this.mg.getValue('vFlag_to_Attach') !== undefined && this.mg.getValue('vFlag_to_Attach')!==null){
			var fContent = this.mg.getValue('vFlag_to_Attach');
			if( fContent.toLowerCase().lastIndexOf("attach", 0) === 0 ) {
				// Começa com "ATTACH" o valor do campo
				this.mg.simulateClick('BTN_Anexar');
			}
        }
    }	
}
